import { createExperimentHook } from '@prisjakt/ui-experiment';

export const useAlternativeFacetNavigation = createExperimentHook(
  'alternative-facet-navigation',
  false,
  {
    useAlternativeFacetNavigation: true,
  }
);

export const useChangelogPositionExperiment = createExperimentHook(
  'changelog-position',
  true,
  { alternate: false }
);

export type SearchResultLayoutExperimentType =
  | boolean
  | 'wide'
  | 'without panorama'
  | 'wide and without panorama';

export const useSearchResultLayoutExperiment = createExperimentHook<
  SearchResultLayoutExperimentType
>('search-result-layout', false, {
  wide: 'wide',
  withoutPanorama: 'without panorama',
  wideAndWithoutPanorama: 'wide and without panorama',
});

export type NewStandardDeliveryTimeType =
  | false
  | 'without-label'
  | 'shipping-label'
  | 'delivery-label';

export const useNewStandardDeliveryTime = createExperimentHook<
  NewStandardDeliveryTimeType
>('new-standard-delivery-time', false, {
  withoutLabel: 'without-label',
  shippingLabel: 'shipping-label',
  deliveryLabel: 'delivery-label',
});

export const useProductSizeVariants = createExperimentHook(
  'product-size-variants',
  false,
  {
    enabled: true,
  }
);

export const useNewSearchApiKWLP = createExperimentHook(
  'new-search-index-kwlp',
  false,
  {
    new: true,
  }
);

export const useProductPageNavExperiment = createExperimentHook(
  'product-page-nav',
  false,
  {
    new: true,
  }
);

export type PanoramaAdInContentExperimentType =
  | boolean
  | 'trailing skyscraper without top panorama ad'
  | 'trailing skyscraper without top panorama ad with panorama ad in content';

export const usePanoramaAdInContentExperiment = createExperimentHook<
  PanoramaAdInContentExperimentType
>('panorama-ad-in-content', false, {
  trailingSkyscraperWithoutTopPanoramaAd:
    'trailing skyscraper without top panorama ad',
  trailingSkyscraperWithoutTopPanoramaAdWithPanoramaAdInContent:
    'trailing skyscraper without top panorama ad with panorama ad in content',
});

export type MobileTopAdExperimentType =
  | boolean
  | 'no top ad + lift ad in price list'
  | 'no top ad';

export const useMobileTopAdExperiment = createExperimentHook<
  MobileTopAdExperimentType
>('mobile-top-ad-experiment', false, {
  removeTopAdPlus: 'no top ad + lift ad in price list',
  removeTopAd: 'no top ad',
});

export const useVisualNavigationInCategoryFacetsExperiment = createExperimentHook(
  'visual-navigation-in-category-facets-experiment',
  false,
  {
    visualNavigation: true,
  }
);

export const useOurChoiceExperiment = createExperimentHook(
  'our-choice-experiment',
  false,
  {
    enabled: true,
  }
);
